import { ProLightEye } from '@nexelem/icons/ProLightEye';
import { Badge, IconButton } from '@nexelem/components';

import { ProLightChevronUp } from '@nexelem/icons/ProLightChevronUp';
import { useEffect } from 'react';
import { ProLightChevronDown } from '@nexelem/icons/ProLightChevronDown';
import clsx from 'clsx';
import { ProSolidEye } from '@nexelem/icons/ProSolidEye';
import { QueueGroup, useGroupedQueuesStore, visibleQueuesCountSelector } from '../../../store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-light-svg-icons';

type SettingsQueueGroupProps = {
  queueGroup: QueueGroup;
  onOpen: (open: boolean) => void;
  isOpen: boolean;
};

export const SettingsQueueGroup = ({
  queueGroup: { name, hex, queues, isHidden, id },
  onOpen,
  isOpen,
}: SettingsQueueGroupProps) => {
  const toggleGroupVisibility = useGroupedQueuesStore((state) => state.toggleGroupDraftVisibility);
  const visibleCount = useGroupedQueuesStore(visibleQueuesCountSelector(id));

  const allGroups = useGroupedQueuesStore((state) => state.displayGroups);
  const maxQueueCount = allGroups.find((group) => group.id === id)?.queues.length || queues.length;

  useEffect(() => {
    onOpen(false);
  }, [onOpen]);

  const handleOpen = () => {
    onOpen(!isOpen);
  };

  const toggle = () => toggleGroupVisibility(id);

  return (
    // DndSortableQueueGroup.tsx apply styles based on .hidden-group class
    <div
      className={clsx(
        'inline-flex grow items-center overflow-hidden',
        isHidden ? 'hidden-group text-text-secondary-darker' : 'text-text-action',
      )}
    >
      <span className="py-1 text-t16-sb">{name}</span>
      <div className="mr-2 ml-auto h-4 w-4 min-w-4 rounded-full" style={{ backgroundColor: `#${hex}` }} />
      <Badge
        className="mr-1"
        StartIcon={visibleCount ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEye} />}
      >
        {`${visibleCount}/${maxQueueCount}`}
      </Badge>
      <div className="flex flex-nowrap">
        <IconButton
          className={clsx(isHidden ? 'text-text-secondary-darker' : 'text-text-focus')}
          Icon={isHidden ? ProLightEye : ProSolidEye}
          size="small"
          onClick={toggle}
        />
        <IconButton Icon={isOpen ? ProLightChevronUp : ProLightChevronDown} size="small" onClick={handleOpen} />
      </div>
    </div>
  );
};
